import Vue from 'vue'
import Vuex from 'vuex'
import markupTool from './modules/markup-tool'
import 'es6-promise/auto'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    markupTool,
  }
})
